import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Tourenplan } from './tourenplan';

@Injectable({ providedIn: 'root' })
export class TourenplanService {
    constructor(
        private http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    assignToVet(tourenplan: Tourenplan) {
        return this.http.post(this.apiBaseUrl + 'tourenplan_tierarzt/update.php', tourenplan);
    }
}
